import * as actionTypes from './actionTypes';
import { BalanceHistoryActionTypes } from './actionTypes';
import { DEFAULT_LIST_PARAMS, ListParams } from '../../hooks/useList/useList';
import { HttpError } from '../../config/Axios/axios-instance';
import { BalanceHistoriesList } from '../../domain/BalanceHistory';

export type BalanceHistoryStateType = {
  balanceHistoryList: BalanceHistoriesList | null;
  balanceHistoryListLoading: boolean;
  balanceHistoryListError: HttpError;
  balanceHistoryFilter: ListParams;
};

export type OrderActionType = BalanceHistoryStateType & {
  type: BalanceHistoryActionTypes;
};

export const initialState: BalanceHistoryStateType = {
  balanceHistoryList: null,
  balanceHistoryListLoading: true,
  balanceHistoryListError: null,
  balanceHistoryFilter: {
    ...DEFAULT_LIST_PARAMS,
    sortBy: 'balanceHistory.createdAt',
    sortDirection: 'DESC',
  },
};

const fetchBalanceHistoryStart = (
  state: BalanceHistoryStateType,
): BalanceHistoryStateType => ({
  ...state,
  balanceHistoryListLoading: true,
});

const fetchBalanceHistorySuccess = (
  state: BalanceHistoryStateType,
  action: OrderActionType,
): BalanceHistoryStateType => ({
  ...state,
  balanceHistoryList: action.balanceHistoryList,
  balanceHistoryListLoading: false,
  balanceHistoryListError: null,
});

const fetchBalanceHistoryFail = (
  state: BalanceHistoryStateType,
  action: OrderActionType,
): BalanceHistoryStateType => ({
  ...state,
  balanceHistoryListError: action.balanceHistoryListError,
  balanceHistoryListLoading: false,
});

const reducer = (state = initialState, action: OrderActionType) => {
  switch (action.type) {
    case actionTypes.FETCH_BALANCE_HISTORY_START:
      return fetchBalanceHistoryStart(state);
    case actionTypes.FETCH_BALANCE_HISTORY_SUCCESS:
      return fetchBalanceHistorySuccess(state, action);
    case actionTypes.FETCH_BALANCE_HISTORY_FAIL:
      return fetchBalanceHistoryFail(state, action);
    default:
      return state;
  }
};

export default reducer;
